<template>
  <div class="animated fadeIn">
      <div class="row">
        <div class="col-sm-12">
          <div v-if="errorMessage.message != ''" class="alert alert-success alert-dismissible">
            <a class="close" data-dismiss="alert" aria-label="close">&times;</a>
            <strong>Success!</strong>{{errorMessage.message}}
          </div>
        </div>
      </div>

      <b-card no-body>
        <div slot="header" class="title_head">
          Search Supplier List
        </div>
           
        <b-collapse id="collapse1" visible>
          <b-card-body>
            <b-row>
              <b-col sm="3">
                <b-form-group >
                  <label for="name">Supplier Name </label>
                   <input type="text" class="form-control" autocomplete="off"  v-model="search.supname" placeholder="Enter Supplier Name">
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group >
                  <label for="name">Company Type </label>
                  <model-list-select :list="srch_cmptyp" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="id" option-text="desc" v-model="search.cmptyp" placeholder="Company Type"></model-list-select>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group >
                  <label for="name">Email </label>
                   <input type="text" class="form-control" autocomplete="off"  v-model="search.email" placeholder="Enter Your Email Address">
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group >
                  <label for="name"></label>
                   <button type="button" v-if="sup_view === true" @click.prevent="getSupplier()" class="btn btn-pill btn-primary serach_bttn" style="margin-top: 24px; margin-left: 16%"><i class="fa fa-search"></i>&nbsp;Search</button>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body>
        <div slot="header" class="title_head">
          Supplier List<span>&nbsp;&nbsp;
            <button v-if="sup_rights === true" type="button" class="btn btn-sm btn-primary label_bttn" variant="secondary" @click.prevent="addsupplier()">Add Supplier</button></span>
        </div>
        <b-collapse id="collapse1" visible>
          <b-card-body>
            <vue-good-table 
            :columns="columns" 
            :rows="rows" 
            mode="remote"
            ref="my-table"
            @on-page-change="onPageChange"
            @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter"
            @on-per-page-change="onPerPageChange"
            :totalRows="totalRecords"
            :pagination-options="{enabled: true ,perPage:5}" 
            styleClass="vgt-table striped bordered table-sm condensed">
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">
                  <i class="fa fa-eye" @click.prevent="viewsupplier(props.row)"></i>

                  <i v-if="sup_rights === true" class="fa fa-edit" @click.prevent="editsupplier(props.row)"></i>
                  <i v-if="sup_rights === true" class="fa fa-trash" @click.prevent="deletesupplier(props.row)"></i> 
                </span>
                <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
              </template>
            </vue-good-table>

            <b-modal title="View supplier" no-close-on-esc no-close-on-backdrop hide-footer size="lg" v-model="largeModal1" @ok="largeModal1 = false">
              <div class="row">
                <div class="col-md-6">
                  <p><h6>Supplier Name:</h6>{{display.name}}</p>
                  <p><h6>Company Type:</h6>{{display.cmptyp}}</p>
                </div>
                <div class="col-md-6">
                  <p><h6>Company email:</h6>{{display.email}}</p>
                  <p><h6>Address:</h6>{{display.add1}}</label></p>
                </div>
              </div>
            </b-modal>

          <b-modal title="Add Supplier" no-close-on-esc no-close-on-backdrop hide-footer size="lg" class="modal-info" v-model="largeModal" @ok="largeModal = false" style="width: 140%; margin: auto;">
            <div class="row">
              <div class="col-md-12">
                <h6 class="page_head">Supplier Detail</h6>
                <div class="row">
                  <b-col sm="6">
                    <b-form-group >
                      <label for="name">Supplier Name <span style="color:red"> *</span></label>
                        <b-form-input type="text" id="name" v-model="supplier.name" :class="{'is-invalid':hasErrors.supnm}" autocomplete="off"  placeholder="Enter Supplier Name"></b-form-input>
                      <small  class="form-text text-muted" v-if="hasErrors.supnm" ><strong style="color: red;">Enter Valid Supplier Name</strong></small>
                    </b-form-group>
                  </b-col>
                  <b-col sm="6">
                    <b-form-group>
                      <label for="name">Company Type </label>
                      <model-list-select :list="contyp" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="desc" option-text="desc" v-model="suptype" placeholder="Select Company Type"></model-list-select>
                    </b-form-group>
                  </b-col>
                </div>

                <b-row>
                  <b-col sm="5">
                    <b-form-group>
                      <label for="name">Address Line 1 </label>
                      <b-form-input type="text" id="add1" v-model="supplier.add" :class="{'is-invalid':hasErrors.supad1}" autocomplete="off"  placeholder="Enter supplier Address 1"></b-form-input>
                      <small  class="form-text text-muted" v-if="hasErrors.supad1" ><strong style="color: red;">Enter Valid Address</strong></small>
                    </b-form-group>
                  </b-col>
                  <b-col sm="5">
                    <b-form-group>
                      <label for="name">Address Line 2 </label>
                      <b-form-input type="text" id="add2" autocomplete="off"  v-model="supplier.add2" :class="{'is-invalid':hasErrors.supad2}" placeholder="Enter supplier Address 2"></b-form-input>
                      <small  class="form-text text-muted" v-if="hasErrors.supad2" ><strong style="color: red;">Enter Valid Address </strong></small>
                    </b-form-group>
                  </b-col> 
                  <b-col sm="2">
                    <b-form-group>
                      <label for="name">Pincode </label>
                      <b-form-input type="text" id="pin" v-model="supplier.pin" :class="{'is-invalid':hasErrors.suppin}" autocomplete="off"  placeholder="Pincode"></b-form-input>
                      <small  class="form-text text-muted" v-if="hasErrors.suppin" ><strong style="color: red;">Enter Valid Pincode </strong></small>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row> 
                  <b-col sm="4">
                    <b-form-group >
                      <label for="name">Country </label>
                      <model-list-select :list="conopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="country_name" option-text="country_name" v-model="con" placeholder="Select Country" @input="state1"></model-list-select>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">State </label>
                      <model-list-select :list="stateopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="state_name" option-text="state_name" v-model="state" placeholder="Select State" @input="city1"></model-list-select >
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">City </label>
                      <model-list-select :list="cityopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="city_name" option-text="city_name" v-model="city" placeholder="Select City"></model-list-select >
                    </b-form-group>
                  </b-col> 
                </b-row>


                <div class="row">
                  <div class="col-md-8">
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="name">Corporate Identity Number</label>
                          <div class="input-group">
                            <input type="text" class="form-control" id="cin" v-model="supplier.cin" onkeyup="this.value = this.value.toUpperCase();" autocomplete="off"  placeholder="Enter Company Identity Number" aria-label="Enter Corporate Identity Number" aria-describedby="btnGroupAddon" :class="{'is-invalid':hasErrors.supcin}">
                          </div>
                          <small class="form-text text-muted" v-if="hasErrors.supcin" ><strong style="color: red;">Enter Valid CIN </strong></small>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="name">CIN Certificate </label>
                          <input :class="{'is-invalid':hasErrors.image1}" type="file" name="image1" id="image1" autocomplete="off"  accept="image/*" class="form-control filesize">
                          <small class="form-text text-muted" v-if="hasErrors.image1"><strong style="color: red;">{{errorMessage.image1}}</strong></small>
                          <p v-if="ed.image1!=''">View Uploaded File <a :href="ed.image1_href" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="name">GST/VAT Number </label>
                          <div class="input-group">
                            <input type="text" class="form-control" id="gst" v-model="supplier.gst" onkeyup="this.value = this.value.toUpperCase();" autocomplete="off"  placeholder="Enter Company GST/VAT Number" aria-label="Input group example" aria-describedby="btnGroupAddon" :class="{'is-invalid':hasErrors.supgst}">
                          </div>
                          <small class="form-text text-muted" v-if="hasErrors.supgst"><strong style="color: red;">Enter Valid GST </strong></small>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="name">GST Certificate </label>
                          <input :class="{'is-invalid':hasErrors.image2}" type="file" name="image2" id="image2" autocomplete="off"  accept="image/*" class="form-control filesize">
                          <small class="form-text text-muted" v-if="hasErrors.image2"><strong style="color: red;">{{errorMessage.image2}}</strong></small>
                          <p v-if="ed.image2!=''">View Uploaded File <a :href="ed.image2_href" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="name">PAN Number</label>
                          <div class="input-group">
                            <input type="text" class="form-control" id="pan" v-model="supplier.pan" onkeyup="this.value = this.value.toUpperCase();" placeholder="Enter Company PAN Number" aria-label="Input group example" autocomplete="off"  aria-describedby="btnGroupAddon" :class="{'is-invalid':hasErrors.suppan}">
                          </div>
                          <small class="form-text text-muted" v-if="hasErrors.suppan"><strong style="color: red;">Enter Valid PAN </strong></small>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="name">PAN Certificate</label>
                          <input :class="{'is-invalid':hasErrors.image3}" type="file" name="image3" id="image3" autocomplete="off"  accept="image/*" class="form-control filesize">
                          <small class="form-text text-muted" v-if="hasErrors.image3"><strong style="color: red;">{{errorMessage.image3}}</strong></small>
                          <p v-if="ed.image3!=''">View Uploaded File <a :href="ed.image3_href" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="name">TAN Number </label>
                          <div class="input-group">
                            <input type="text" class="form-control" id="tan" v-model="supplier.tan" onkeyup="this.value = this.value.toUpperCase();" autocomplete="off"  placeholder="Enter Company Tan Number" aria-label="Input group example" aria-describedby="btnGroupAddon" :class="{'is-invalid':hasErrors.suptan}">
                          </div>
                          <small class="form-text text-muted" v-if="hasErrors.suptan"><strong style="color: red;">Enter Valid TAN </strong></small>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group">
                          <label for="name">TAN Certificate</label>
                          <input :class="{'is-invalid':hasErrors.image4}" type="file" name="image4" id="image4" autocomplete="off"  accept="image/*" class="form-control filesize">
                          <small class="form-text text-muted" v-if="hasErrors.image4"><strong style="color: red;">{{errorMessage.image4}}</strong></small>
                          <p v-if="ed.image4!=''">View Uploaded File <a :href="ed.image4_href" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="row">
                     <b-col sm="12">
                        <b-form-group>
                          <label for="name">Contact No. <span style="color:red"> *</span></label>
                          <b-form-input type="text" id="phone" v-model="supplier.phone" autocomplete="off"  :class="{'is-invalid':hasErrors.supph}" placeholder="Enter Your Contact Number"></b-form-input>
                          <small  class="form-text text-muted" v-if="hasErrors.supph"><strong style="color: red;">Enter Valid Contact Number</strong></small>
                        </b-form-group>
                      </b-col>
                      <b-col sm="12">
                        <b-form-group>
                          <label for="name">Email </label>
                          <b-form-input type="text" v-model="supplier.email" :class="{'is-invalid':hasErrors.supeml}" autocomplete="off"  placeholder="Enter Your E-Mail Id"></b-form-input>
                          <small  class="form-text text-muted" v-if="hasErrors.supeml"><strong style="color: red;">Enter Valid Eamil  Id</strong></small>
                        </b-form-group>
                      </b-col>
                      <div class="col-sm-12">
                        <div class="form-group">
                          <label for="name">Company Logo </label>
                          <input :class="{'is-invalid':hasErrors.image5}" type="file" name="image5" id="image5" autocomplete="off"  accept="image/*" class="form-control filesize">
                          <small class="form-text text-muted" v-if="hasErrors.image5"><strong style="color: red;">{{errorMessage.image5}}</strong></small>
                          <p v-if="ed.image5!=''">View Uploaded File <a :href="ed.image5_href" target="blank"><i class="fa fa-file-image-o" style="color: skyblue; cursor: pointer;"></i></a></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
  
              <div class="col-md-12">
                <h6 class="page_head">Contact Person Detail</h6>
                <b-row>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">Contact Person Name </label>
                      <b-form-input type="text" id="contact" v-model="supplier.contact" autocomplete="off"  :class="{'is-invalid':hasErrors.supcont}" placeholder="Enter Contact Person Name"></b-form-input>
                      <small  class="form-text text-muted" v-if="hasErrors.supcont" ><strong style="color: red;">Enter Valid  Name</strong></small>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">Contact Number </label>
                      <b-form-input type="text" id="contactno" autocomplete="off"  v-model="supplier.contactno" :class="{'is-invalid':hasErrors.supcontno}" placeholder=" Enter Contact Phone Number"></b-form-input>
                      <small  class="form-text text-muted" v-if="hasErrors.supcontno" ><strong style="color: red;">Enter Valid Contact Number</strong></small>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">Contact Email </label>
                      <b-form-input type="text" id="contactemail" v-model="supplier.contactemail" autocomplete="off"  :class="{'is-invalid':hasErrors.supconteml}" placeholder="Enter Contact Person E-mail Id"></b-form-input>
                      <small  class="form-text text-muted" v-if="hasErrors.supconteml" ><strong style="color: red;">Enter Valid Eamil Id </strong></small>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                 <b-col sm="12">
                    <b-form-group>
                      <label for="name">Supplier Company Profile </label>
                      <small  class="form-text text-muted" v-if="hasErrors.supplierprf" ><strong style="color: red;">Profile cannot be greater than 255 Character</strong></small>
                     <vue-editor  v-model="supplier.profile" :editorToolbar="customToolbar" ></vue-editor>
                    </b-form-group>
                  </b-col>
                </b-row>

                <h6 class="page_head">Bank Details</h6>

                <div class="row">
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="name">Bank Name </label>
                      <input type="text" class="form-control" id="bankname" v-model="supplier.bankname" autocomplete="off"  :class="{'is-invalid':hasErrors.bankname}" placeholder="Enter your Bank Name">
                      <small class="form-text text-muted" v-if="hasErrors.bankname" ><strong style="color: red;">Enter Valid Bank Name</strong></small>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="name">Account Number </label>
                      <input type="text" class="form-control" id="banknumber" name="banknumber" v-model="supplier.banknumber" :class="{'is-invalid':hasErrors.banknumber}" autocomplete="off"  placeholder="Enter your Bank Account Number">
                      <small class="form-text text-muted" v-if="hasErrors.banknumber"><strong style="color: red;">Enter Valid Bank Account Number</strong></small>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="name">Account Holder Name </label>
                      <input type="text" class="form-control" id="bankholder" name="bankholder" v-model="supplier.bankholder" autocomplete="off"  :class="{'is-invalid':hasErrors.bankholder}" placeholder="Enter Account Holder Name">
                      <small class="form-text text-muted" v-if="hasErrors.bankholder"><strong style="color: red;">Enter Valid Account Holder Name</strong></small>
                    </div>
                  </div>
                </div>
                <div class="row">   
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="name">IFSC Code </label>
                      <input type="text" class="form-control" id="bankifsc" name="bankifsc" v-model="supplier.bankifsc" autocomplete="off"  :class="{'is-invalid':hasErrors.bankifsc}" placeholder="Enter Bank IFSC Code">
                      <small class="form-text text-muted" v-if="hasErrors.bankifsc"><strong style="color: red;">Enter Valid IFSC Code</strong></small>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="name">Branch </label>
                      <input type="text" class="form-control" id="bankbranch" name="bankbranch" v-model="supplier.bankbranch" :class="{'is-invalid':hasErrors.bankbranch}" placeholder="Enter Branch Name">
                      <small class="form-text text-muted" v-if="hasErrors.bankbranch"><strong style="color: red;">Enter Valid Bank Branch</strong></small>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="name">MICR Code </label>
                      <input type="text" class="form-control" id="bankmicr" name="bankmicr" v-model="supplier.bankmicr" :class="{'is-invalid':hasErrors.bankmicr}" autocomplete="off"  placeholder="Enter MICR code">
                      <small class="form-text text-muted" v-if="hasErrors.bankmicr"><strong style="color: red;">Enter Valid MICR Code</strong></small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label for="name">Swift Code </label>
                      <input type="text" class="form-control" id="bankswift" name="bankswift" v-model="supplier.bankswift" :class="{'is-invalid':hasErrors.bankswift}" autocomplete="off"  placeholder="Enter Bank Swift Code">
                      <small class="form-text text-muted" v-if="hasErrors.bankswift"><strong style="color: red;">Enter Valid Swift Code</strong></small>
                    </div>
                  </div>   
                </div>
              </div>
            </div>

            <div class="card-footer modal_footer">
            <b-row>
              <b-col sm="12">
                 <button type="save" class="btn btn-sm btn-primary" v-if="saveBtn" @click.prevent="Submit()"><i class="fa fa-dot-circle-o"></i> Save</button>
                 <button type="save" class="btn btn-sm btn-primary" v-if="editBtn" @click.prevent="Update()"><i class="fa fa-dot-circle-o"></i> Save</button>

              </b-col>
            </b-row>

          </div>
          </b-modal>
           <b-modal
            title="Plan Limit Reached"
            size="sm"
            class="modal-warning"
            ok-only 
            v-model="plan_modal"
          >
          <b-row>
            <b-col sm="2">
                <i class="fa fa-exclamation" style="font-size:40px;color:red"></i>
              </b-col>
              <b-col sm="10">
                <b-row>
                <b>You have hit the plan limit.</b>
                </b-row>
                <b-row>
                  You have reached the limit of adding Supplier. Please upgrade your plan to add more Suppliers.
                </b-row>
              </b-col>
            </b-row>
          </b-modal>
        </b-card-body>
      </b-collapse>
    </b-card>

  <Spinner v-if="loading"></Spinner>
     
  </div>
</template>


<script>
  import Spinner from '../../spinner.vue'
  import { VueEditor } from 'vue2-editor'
  export default {
    name:'supplier',
    components: {
      VueEditor,Spinner
    },

    data () {
      return {
        // pg_view:false,
        // pg_rights:false,
        access_token:null,
        plan_modal:false,
        customToolbar: [
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }]
        ],
        comf_time:false,
        cfrst_time:false,
        supfrst_time:false,
        shpfrst_time:false,
        supplier_id:'',
        largeModal1:false,
        largeModal:false,
        editBtn:false,
        saveBtn:true,
        loading:false,
        suptype:null,
        city:null,
        state:null,
        con:null,
        cityopt:[],
        stateopt:[],
        maximumSize: 500000,
        allowableTypes: ['image/jpg', 'image/jpeg', 'image/png'],
        conopt:[],
        contyp:[],
        srch_cmptyp:[],
        display:{
          name:null,
          cmptyp:null,
          email:null,
          add1:null,
        },

        supplier:{
          add:'',
          name:'',
          add2:'',
          pin:'',
          phone:'',
          email:'',
          gst:'',
          pan:'',
          cin:'',
          tan:'',
          contact:'',
          contactno:'',
          contactemail:'',
          profile:'',
          image:'',
          bankname:'',
          banknumber:'',
          bankholder :'',
          bankifsc:'',
          bankbranch:'',
          bankmicr :'',
          bankswift :'',
        },

        search:{
          supname:'',
          cmptyp:null,
          email:'',
        },

        columns: [
        {
          label: 'Supplier Name',
          field: 'sup_cmp_name',
          width: '15% !important'
        },
        {
          label: 'Company Type',
          field: 'companytypes.desc',
          width: '15% !important'
        },
        {
          label: 'Contact No.',
          field: 'sup_cmp_phone',
          width: '10% !important'
        },
        {
          label: 'Email',
          field: 'sup_cmp_email',
          width: '15% !important'
        },
        {
          label: 'GST',
          field: 'sup_cmp_gst',
          width: '15% !important'
        },
        {
          label: 'PAN',
          field: 'sup_cmp_pan',
          width: '15% !important'
        },
        {
          label: 'Action',
          field: 'action',
          width: '15% !important'
        },
      ],

      rows: [],
      totalRecords: 0,
      serverParams: {
      columnFilters: {
                 },
      sort: {
        // field: 'purchase_id', 
        // type: 'asc',
            },
      page: 1, 
      perPage: 5
      },
      ed:{
        image1:'',
        image2:'',
        image3:'',
        image4:'',
        image5:'',
        image1_href:'',
        image2_href:'',
        image3_href:'',
        image4_href:'',
        image5_href:'',
      },
      hasErrors:{
        message:false,
        supnm:false,
        supad1:false,
        supad2:false,
        suppin:false,
        supph:false,
        supeml:false,
        supgst:false,
        suppan:false,
        supcin:false,
        suptan:false,
        supcont:false,
        supcontno:false,
        supconteml:false, 
        supplierprf:false,
        image1:false,
        image2:false,
        image3:false,
        image4:false,
        image5:false,
        bankname:false,
        banknumber:false,
        bankholder :false,
        bankifsc:false,
        bankbranch:false,
        bankmicr:false,
        bankswift:false,
      },
      errorMessage:{
        message:'',
        image1:null,
        image2:null,
        image3:null,
        image4:null,
        image5:null,
      }
    }
  },
  computed:{
    sup_view: function(){
      if(this.$store.getters.get_sup_view === true){
          this.shopuser('comp');
          this.getSupplier('comp');
          this.contr('comp');
          this.companytype('comp');
          return true
      }
      else{
        return false
      }
    },

    sup_rights: function(){
      return this.$store.getters.get_sup_rights
    },
  },
  created(){
    if(localStorage.authUser != null){
          this.access_token = '?access_token='+localStorage.authUser
        }
    // var roles = JSON.parse(localStorage.getItem('roles'))
    // if(roles[13].page_name == 14){
    //   this.pg_view = roles[13].view
    //   this.pg_rights = roles[13].rights
    //   if(this.pg_view){
    //     this.shopuser();
    //     this.getSupplier();
    //     this.contr();
    //     this.companytype();
    //   }
    // }
    
  },

  methods:{
    shopuser(val){
      if(val === 'comp'){
          if(this.shpfrst_time === false){
            this.shpfrst_time = true
          }
          else{
            return
          }
        }
      // console.log("shopuser")
      var _this=this
      this.$http.get('/api/shopusers').then(function(response){

      }).catch(function(error){
        if (error.response.status === 401) {
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null)
          _this.$router.push('/');
        }
        if(error.response.data.error.message === "Cannot read property 'cmpname' of null"){
          localStorage.clear();
          _this.$store.commit('SET_AUTH_USER', null)
          _this.$router.push('/');
        }
      })
    },
    // getSupplier(){
    //   var self = this;
    //   this.$http.get('/api/suppliers').then(function (response) {
    //     self.rows=response.data
    //   })
    //   .catch(function (error) {
    //     console.log("error.response");
    //   });
    // },
       updateParams(newProps) {
          this.serverParams = Object.assign({}, this.serverParams, newProps);
      },
    
    onPageChange(params) { 
  
           this.updateParams({page: params.currentPage});
           this.getSupplier();
    },

    onPerPageChange(params) {
      this.updateParams({perPage: params.currentPerPage,page:1});
      this.getSupplier();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },page:1
      });
      this.getSupplier();
    },
    
    onColumnFilter(params) {
      this.updateParams(params);
      this.getSupplier();
    },
    addsupplier(){
      var _this = this
        this.loading = true;
        this.$http.get('/api/suppliers/chk_plan_count').then(function(response){
          // console.log(response)
          _this.loading = false;
          if('message' in response.data){
            if(response.data.message === false){
                _this.plan_modal=false;
                _this.saveBtn = true
                _this.editBtn = false
                _this.contr1ed('101');
                _this.state1ed('22');
                _this.city1ed('2707');
                _this.largeModal = true
                _this.reset_error()
                _this.reset();
               }
            else{
              _this.plan_modal=true;
            }
          }
          else{
            console.log('something went wrong')
          }
          }).catch(function(error){
            console.log(error)
          });
    },
    viewsupplier(supplierid){
      var _this = this
      _this.display.name = null
      _this.display.cmptyp = null
      _this.display.email = null
      _this.display.add1 = null
      this.largeModal1 = true
      _this.display.name = supplierid.sup_cmp_name

      if(supplierid.sup_cmp_type!=null){
   
       this.$http.get('/api/companytypes/'+supplierid.sup_cmp_type).then(function(response){
        
        _this.display.cmptyp = response.data.desc
      }).catch(function(error){
        console.log(error)
      }) 
      }

      _this.display.email = supplierid.sup_cmp_email
      _this.display.add1 = supplierid.address1
    },
    contr1ed(option){
      var _this=this
      this.$http.get('/api/countries/'+option).then(function(response){
        _this.con = response.data
      }).catch(function(error){
        console.log(error)
      })
      this.$http.get('/api/states?&filter[where][country_id]='+option).then(function(response){
        _this.stateopt = response.data;
      }).catch(function(error){
        console.log(error)
      })
    },
    state1ed(conopt){
      var _this=this
      this.$http.get('/api/states/'+conopt).then(function(response){
        _this.state = response.data;
      }).catch(function(error){
        console.log(error)
      })
      this.$http.get('/api/cities?filter[where][state_id]='+conopt).then(function(response){
        _this.cityopt = response.data
      }).catch(function(error){
        console.log(error)
      })
    },
    city1ed(stateopt){
      var _this=this
      this.$http.get('/api/cities/'+stateopt).then(function(response){
        _this.city = response.data
      }).catch(function(error){
        console.log(error.response)
      })
    },
    suptyp1ed(suptypopt){
      var _this=this
      this.$http.get('/api/companytypes/'+suptypopt).then(function(response){
        _this.suptype = response.data
      }).catch(function(error){
        console.log(error)
      })
    },
    editsupplier(supplierid){
      this.reset_error()
      this.reset();
      this.saveBtn = false
      this.editBtn = true
      this.largeModal = true
      this.supplier.name = supplierid.sup_cmp_name
      if(supplierid.sup_cmp_type!=null){
        this.suptyp1ed(supplierid.sup_cmp_type)
      }
      this.supplier.add = supplierid.address1
      this.supplier.add2 = supplierid.address2
      if(supplierid.country_code!=null){
        this.contr1ed(supplierid.country_code)
      }
      if(supplierid.state_code!=null){
        this.state1ed(supplierid.state_code)
      }
      if(supplierid.city!=null){
        this.city1ed(supplierid.city)
      }
      this.supplier.pin = supplierid.pincode
      this.supplier.phone = supplierid.sup_cmp_phone
      this.supplier.email = supplierid.sup_cmp_email
      this.supplier.gst = supplierid.sup_cmp_gst
      this.supplier.pan = supplierid.sup_cmp_pan
      this.supplier.cin = supplierid.sup_cmp_cin
      this.supplier.tan = supplierid.sup_cmp_tan
      this.supplier.contact = supplierid.contact_person_name
      this.supplier.contactno = supplierid.contact_no
      this.supplier.contactemail = supplierid.contact_email
      this.supplier.profile = supplierid.supplierdetails.sup_cmp_profile
      this.supplier.bankname = supplierid.supplierbanks.bank_name
      this.supplier.banknumber = supplierid.supplierbanks.acc_number
      this.supplier.bankholder = supplierid.supplierbanks.bank_holder_name
      this.supplier.bankifsc = supplierid.supplierbanks.ifsc_code
      this.supplier.bankbranch = supplierid.supplierbanks.branch
      this.supplier.bankmicr = supplierid.supplierbanks.micr_code
      this.supplier.bankswift = supplierid.supplierbanks.swift_code
      this.ed.image1 = supplierid.supplierdetails.sup_cmp_cic_cert
      this.ed.image2 = supplierid.supplierdetails.sup_cmp_gst_cert
      this.ed.image3 = supplierid.supplierdetails.sup_cmp_pan_cert
      this.ed.image4 = supplierid.supplierdetails.sup_cmp_tan_cert
      this.ed.image5 = supplierid.supplierdetails.sup_cmp_logo
      this.ed.image1_href = this.$http.defaults.baseURL+'/api/containers/pics/download/'+supplierid.supplierdetails.sup_cmp_cic_cert+this.access_token
      this.ed.image2_href = this.$http.defaults.baseURL+'/api/containers/pics/download/'+supplierid.supplierdetails.sup_cmp_gst_cert+this.access_token
      this.ed.image3_href = this.$http.defaults.baseURL+'/api/containers/pics/download/'+supplierid.supplierdetails.sup_cmp_pan_cert+this.access_token
      this.ed.image4_href = this.$http.defaults.baseURL+'/api/containers/pics/download/'+supplierid.supplierdetails.sup_cmp_tan_cert+this.access_token
      this.ed.image5_href = this.$http.defaults.baseURL+'/api/containers/pics/download/'+supplierid.supplierdetails.sup_cmp_logo+this.access_token
      this.supplier_id = supplierid.supplier_id
    },

    getSupplier(val){
      if(val === 'comp'){
          if(this.supfrst_time === false){
            this.supfrst_time = true
          }
          else{
            return
          }
        }
      // console.log("getSupplier")
      var _this=this
      var data = [];
      this.rows = [];
      this.loading = true;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var supname = this.search.supname
      var email = this.search.email
      supname = supname.split(' ').join('_')
      email = email.split(' ').join('_')

      if(this.search.supname!=''){
        data=data+"&filter[where][sup_cmp_name][ilike]=%"+supname+"%"
      }
      if(this.search.cmptyp!=null){
        if(this.search.cmptyp.id!=undefined){
          var cmptyp = this.search.cmptyp.id
          data= data+"&filter[where][sup_cmp_type]="+cmptyp          
        }
      }
      if(this.search.email!=''){
        data= data+"&filter[where][sup_cmp_email][ilike]=%"+email+"%"
      }
    
      this.$http.get('/api/suppliers/supplier_search?params='+JSON.stringify(filteParam)+data)
      .then(function(response){
          _this.totalRecords = response.data[0].totalRecords;
          response.data.shift()
          if(response.data != undefined)
          _this.rows=response.data;
          _this.loading = false
      }).catch(function(error){
        console.log(error)
        _this.loading = false
      })
    },
    deletesupplier(supplierid){
      var r = confirm("Are you sure you want to delete?");
      if (r == true) {
        var _this = this
        var id = supplierid.id;
        this.loading=true
        this.$http.delete('/api/suppliers/'+id).then(function (response){
          _this.getSupplier();
          _this.loading=false
        })
        .catch(function (error){
          _this.loading=false
          console.log(error);
        });
      }
    },
    companytype(val){
      if(val === 'comp'){
          if(this.comf_time === false){
            this.comf_time = true
          }
          else{
            return
          }
        }
      // console.log("companytype")
      var _this = this
      this.$http.get('/api/companytypes').then(function(response){
        _this.contyp = response.data
        _this.srch_cmptyp = response.data
      }).catch(function(error){
        console.log(error)
      })
    },
    contr(val){
      if(val === 'comp'){
          if(this.cfrst_time === false){
            this.cfrst_time = true
          }
          else{
            return
          }
        }
      // console.log("contr")
      var _this=this
      this.$http.get('/api/countries').then(function(response){
        _this.conopt = response.data;
      }).catch(function(error){
        console.log(error)
      })
    },
    state1(conopt){
      this.stateopt = [];
      this.cityopt=[];
      this.state =null
      this.city = null
      var _this=this
      var id=conopt.id
      this.$http.get('/api/states?filter[where][country_id]='+id).then(function(response){
        _this.stateopt=  response.data;
      }).catch(function(error){
        console.log(error)
      })
    },
    city1(stateopt){
      this.cityopt=[];
      this.city=null
      var _this=this
      var id=stateopt.id
      this.$http.get('/api/cities?filter[where][state_id]='+id).then(function(response){
        _this.cityopt=  response.data;
      }).catch(function(error){
        console.log(error)
      })
    },
    image1(callback){
      var _this = this
      const image1 = document.querySelector('#image1');
      if(this.ed.image1!=='' && this.ed.image1!==null){
        if(image1.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.ed.image1)
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return '';
          });
        }else{
          return this.ed.image1
        }
      }else{
        if(image1.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image1.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return '';
          });
        }else{
          return '';
        }        
      }
    },

    image2(callback){
      var _this = this
      const image2 = document.querySelector('#image2');
      if(this.ed.image2!=='' && this.ed.image2!==null){
        if(image2.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.ed.image2)
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return '';
          });
        }else{
          return this.ed.image2
        }
      }else{
        if(image2.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image2.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            console.log(error);
          });
        }else{
          return '';        
        }
      }
    },

    image3(callback){
      var _this = this
      const image3 = document.querySelector('#image3');
      if(this.ed.image3!=='' && this.ed.image3!==null){
        if(image3.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image3.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.ed.image3)
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return '';
          });
        }else{
          return this.ed.image3
        }
      }else{
        if(image3.files[0]!==undefined){
          var formData = new FormData();
          formData.append('image', image3.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            console.log(error);
          });
        }else{
          return '';
        }
      }
    },

    image4(callback){
      var _this = this
      const image4 = document.querySelector('#image4');
      if(this.ed.image4!=='' && this.ed.image4!==null){
        if(image4.files[0]!=undefined){
          var formData = new FormData();
          formData.append('image', image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.ed.image4)
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return '';
          });
        }else{
          return this.ed.image4
        }
      }else{
        if(image4.files[0]!==undefined){
          var formData = new FormData();
          formData.append('image', image4.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            console.log(error);
          });
        }else{
          return '';
        }
      }
    },


    image5(callback){
      var _this = this
      const image5 = document.querySelector('#image5');
      if(this.ed.image5!=='' && this.ed.image5!==null){
        if(image5.files[0]!==undefined){
          var formData = new FormData();
          formData.append('image', image5.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
          .then(function (response) {
            _this.$http.delete('/api/containers/pics/files/'+_this.ed.image5)
            return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            return '';
          });
        }else{
          return this.ed.image5
        }
      }else{
        if(image5.files[0]!==undefined){
          var formData = new FormData();
          formData.append('image', image5.files[0]);
          return this.$http.post('/api/containers/pics/upload', formData)
            .then(function (response) {
              return response.data.result.files.image[0].name;
          })
          .catch(function (error) {
            console.log(error);
          });
        }else{
          return '';
        }
      }
    },

    reset_error(){
      var _this = this
      _this.hasErrors.supnm=false;
      _this.hasErrors.supad1=false;
      _this.hasErrors.supad2=false;
      _this.hasErrors.suppin=false;
      _this.hasErrors.supph=false;
      _this.hasErrors.supeml=false;
      _this.hasErrors.supgst=false;
      _this.hasErrors.suppan=false;
      _this.hasErrors.supcin=false;
      _this.hasErrors.suptan=false;
      _this.hasErrors.supcont=false;
      _this.hasErrors.supcontno=false;
      _this.hasErrors.supconteml=false;
      _this.hasErrors.supplierprf=false;
      _this.hasErrors.image1=false;
      _this.hasErrors.image2=false;
      _this.hasErrors.image3=false;
      _this.hasErrors.image4=false;
      _this.hasErrors.image5=false;
      _this.hasErrors.bankname=false;
      _this.hasErrors.banknumber=false;
      _this.hasErrors.bankholder =false;
      _this.hasErrors.bankifsc=false;
      _this.hasErrors.bankbranch=false;
      _this.hasErrors.bankmicr =false;
      _this.hasErrors.bankswift =false;
    },

    validation(boolean){
      var _this = this
      const image1 = document.querySelector('#image1');
      const image2 = document.querySelector('#image2');
      const image3 = document.querySelector('#image3');
      const image4 = document.querySelector('#image4');
      const image5 = document.querySelector('#image5');

      this.reset_error()

      var submit_true='0';
      var nrex=/^[a-zA-Z\s]{3,100}$/
      var regex=/^[a-zA-Z0-9\s]{3,100}$/
      var aregex = /^[a-zA-Z0-9\s,.'-/]{3,100}$/
      var prex=/^[0-9]{10,15}$/
      var pirex=/^[0-9]{6}$/
      var accregex=/^[0-9]{3,30}$/
      var eregex= /^[a-z][a-zA-Z0-9_]*(\.[a-zA-Z][a-zA-Z0-9_]*)?@[a-z][a-zA-Z-0-9]*\.[a-z]+(\.[a-z]+)?$/      

      if (aregex.test(this.supplier.name)==false){
        _this.hasErrors.supnm=true;
        submit_true='1'
      }else if(this.supplier.name.length > 100){
        _this.hasErrors.supnm=true;
        submit_true=1        
      }

      if(this.supplier.add != ""){
        if (aregex.test(this.supplier.add)==false){
          _this.hasErrors.supad1=true;
          submit_true=1
        }else if(this.supplier.add.length > 100){
          _this.hasErrors.supad1=true;
          submit_true=1      
        }
      }

      if(this.supplier.add2 != ""){
        if (aregex.test(this.supplier.add2)==false){
          _this.hasErrors.supad2=true;
          submit_true=1
        }else if(this.supplier.add2.length > 100){
          _this.hasErrors.supad2=true;
          submit_true=1      
        }
      }

      if(this.supplier.pin != ""){
        if (pirex.test(this.supplier.pin)==false){
          _this.hasErrors.suppin=true;
          submit_true=1
        }else if(this.supplier.pin.length > 10){
          _this.hasErrors.suppin=true;
          submit_true=1      
        }
      }

      if (prex.test(this.supplier.phone)==false){
        _this.hasErrors.supph=true;
        submit_true=1
      }else if(this.supplier.phone.length > 15){
        _this.hasErrors.supph=true;
        submit_true=1      
      }

      if(this.supplier.email != ""){
        if (eregex.test(this.supplier.email)==false){
          _this.hasErrors.supeml=true;
          submit_true=1
        }else if(this.supplier.email.length > 70){
          _this.hasErrors.supeml=true;
          submit_true=1      
        }
      }

      if(this.supplier.gst != ""){
        if (regex.test(this.supplier.gst)==false){
          _this.hasErrors.supgst=true;
          submit_true=1
        }else if(this.supplier.gst.length > 15){
          _this.hasErrors.supgst=true;
          submit_true=1      
        }
      }

      if(this.supplier.pan != ""){
        if (regex.test(this.supplier.pan)==false){
          _this.hasErrors.suppan=true;
          submit_true=1
        }else if(this.supplier.pan.length > 10){
          _this.hasErrors.suppan=true;
          submit_true=1      
        }
      }

      if(this.supplier.cin != ""){
        if (regex.test(this.supplier.cin)==false){
          _this.hasErrors.supcin=true;
          submit_true=1
        }else if(this.supplier.cin.length > 25){
          _this.hasErrors.supcin=true;
          submit_true=1      
        }
      }

      if(this.supplier.tan != ""){
        if (regex.test(this.supplier.tan)==false){
          _this.hasErrors.suptan=true;
          submit_true=1
        }else if(this.supplier.tan.length > 12){
          _this.hasErrors.suptan=true;
          submit_true=1      
        }
      }

      if(this.supplier.profile != ""){
        if(this.supplier.profile.length > 255){
          _this.hasErrors.supplierprf=true;
          submit_true=1      
        }
      }



      if(this.supplier.contact !== ""){
        if (nrex.test(this.supplier.contact)==false){
          _this.hasErrors.supcont=true;
          submit_true=1
        }else if(this.supplier.contact.length > 100){
          _this.hasErrors.supcont=true;
          submit_true=1      
        }
      }

      if(this.supplier.contactno !== ""){
        if (prex.test(this.supplier.contactno)==false){
          _this.hasErrors.supcontno=true;
          submit_true=1
        }else if(this.supplier.contactno.length > 15){
          _this.hasErrors.supcontno=true;
          submit_true=1      
        }
      }

      if(this.supplier.contactemail !== ""){
        if (eregex.test(this.supplier.contactemail)==false){
          _this.hasErrors.supconteml=true;
          submit_true=1
        }else if(this.supplier.contactemail.length > 70){
          _this.hasErrors.supconteml=true;
          submit_true=1      
        }
      }

      // Supplier Bank Name
      if(this.supplier.bankname != ""){
        if (regex.test(this.supplier.bankname)==false)  {
          // console.log('Error 1')
          _this.hasErrors.bankname=true;
          submit_true=1
        }else if(this.supplier.bankname.length > 20){
          // console.log('Error 2')
          _this.hasErrors.bankname=true;
          submit_true=1          
        }
      }

      // Supplier Bank Account Number
      if(this.supplier.banknumber != ""){
        if (accregex.test(this.supplier.banknumber)==false)  {
          _this.hasErrors.banknumber=true;
          submit_true=1
        }else if(this.supplier.banknumber.length > 20){
          _this.hasErrors.banknumber=true;
          submit_true=1          
        }
      }

      // Supplier Bank Account Holder
      if(this.supplier.bankholder != ""){
        if (regex.test(this.supplier.bankholder)==false)  {
          _this.hasErrors.bankholder=true;
          submit_true=1
        }else if(this.supplier.bankholder.length > 50){
          _this.hasErrors.bankholder=true;
          submit_true=1          
        }
      }

      // Supplier IFSC
      if(this.supplier.bankifsc != ""){
        if (regex.test(this.supplier.bankifsc)==false)  {
          _this.hasErrors.bankifsc=true;
          submit_true=1
        }else if(this.supplier.bankifsc.length > 20){
          _this.hasErrors.bankifsc=true;
          submit_true=1          
        }
      }

      // Supplier Bank Branch
      if(this.supplier.bankbranch != ""){
        if (regex.test(this.supplier.bankbranch)==false)  {
          _this.hasErrors.bankbranch=true;
          submit_true=1
        }else if(this.supplier.bankbranch.length > 20){
          _this.hasErrors.bankbranch=true;
          submit_true=1          
        }
      }

      // Supplier Bank MICR
      if(this.supplier.bankmicr != ""){
        if (regex.test(this.supplier.bankmicr)==false)  {
          _this.hasErrors.bankmicr=true;
          submit_true=1
        }else if(this.supplier.bankmicr.length > 20){
          _this.hasErrors.bankmicr=true;
          submit_true=1          
        }
      }

      // Supplier Bank Swift
      if(this.supplier.bankswift != ""){
        if (regex.test(this.supplier.bankswift)==false)  {
          _this.hasErrors.bankswift=true;
          submit_true=1
        }else if(this.supplier.bankswift.length > 20){
          _this.hasErrors.bankswift=true;
          submit_true=1          
        }
      }
     
      if(image1.files[0]!=undefined){
        if(image1.files[0].size>this.maximumSize){
          this.hasErrors.image1=true;
          this.errorMessage.image1="Image Size Cannot Be Greater Than 500kb"
          submit_true=1
        }
        if(this.allowableTypes.indexOf(image1.files[0].type.toLowerCase())=== -1){
          this.hasErrors.image1=true;
          this.errorMessage.image1="Invalid Image Type"
          submit_true=1
        }
      }

      if(image2.files[0]!=undefined){
        if(image2.files[0].size>this.maximumSize){
          this.hasErrors.image2=true;
          this.errorMessage.image2="Image Size Cannot Be Greater Than 500kb"
          submit_true=1
        }
        if(this.allowableTypes.indexOf(image2.files[0].type.toLowerCase())=== -1){
          this.hasErrors.image2=true;
          this.errorMessage.image2="Invalid Image Type"
          submit_true=1
        }
      }

      if(image3.files[0]!=undefined){
        if(image3.files[0].size>this.maximumSize){
          this.hasErrors.image3=true;
          this.errorMessage.image3="Image Size Cannot Be Greater Than 500kb"
          submit_true=1
        }
        if(this.allowableTypes.indexOf(image3.files[0].type.toLowerCase())=== -1){
          this.hasErrors.image3=true;
          this.errorMessage.image3="Invalid Image Type"
          submit_true=1
        }
      }

      if(image4.files[0]!=undefined){
        if(image4.files[0].size>this.maximumSize){
          this.hasErrors.image4=true;
          this.errorMessage.image4="Image Size Cannot Be Greater Than 500kb"
          submit_true=1
        }
        if(this.allowableTypes.indexOf(image4.files[0].type.toLowerCase())=== -1){
          this.hasErrors.image4=true;
          this.errorMessage.image4="Invalid Image Type"
          submit_true=1
        }
      }

      if(image5.files[0]!=undefined){
        if(image5.files[0].size>this.maximumSize){
          this.hasErrors.image5=true;
          this.errorMessage.image5="Image Size Cannot Be Greater Than 500kb"
          submit_true=1
        }
        if(this.allowableTypes.indexOf(image5.files[0].type.toLowerCase())=== -1){
          this.hasErrors.image5=true;
          this.errorMessage.image5="Invalid Image Type"
          submit_true=1
        }
      }      
      return submit_true
    },

    Update(){
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;

      var submit_true = this.validation()
      var _this=this

      if (submit_true=='0') {
        this.loading=true
        var sup1 = {};

          Promise.all([this.image1(),this.image2(),this.image3(),this.image4(),this.image5()]).then(user=>{
            sup1.sup_cmp_name=this.supplier.name

            if(this.suptype != null){
              sup1.sup_cmp_type=this.suptype.id
            }else{
              sup1.sup_cmp_type=null
            }


            sup1.address1=this.supplier.add
            sup1.address2=this.supplier.add2
            sup1.pincode=this.supplier.pin

            if(this.city != null){
              sup1.city=this.city.id
            }else{
              sup1.city=null       
            }

            if(this.state != null){
              sup1.state_code=this.state.id
            }else{
              sup1.state_code=null
            }

            if(this.con != null){
              sup1.country_code=this.con.id
            }else{
              sup1.country_code=null
            }

            sup1.sup_cmp_phone=this.supplier.phone
            sup1.sup_cmp_email=this.supplier.email
            sup1.sup_cmp_gst=this.supplier.gst
            sup1.sup_cmp_pan=this.supplier.pan
            sup1.sup_cmp_cin=this.supplier.cin
            sup1.sup_cmp_tan=this.supplier.tan
            sup1.contact_person_name=this.supplier.contact
            sup1.contact_no=this.supplier.contactno
            sup1.contact_email=this.supplier.contactemail
            sup1.sup_cmp_cic_cert=user[0]
            sup1.sup_cmp_gst_cert=user[1]
            sup1.sup_cmp_pan_cert=user[2]
            sup1.sup_cmp_tan_cert=user[3]
            sup1.sup_cmp_logo=user[4]
            sup1.sup_cmp_profile=this.supplier.profile
            sup1.bank_name=this.supplier.bankname
            sup1.acc_number=this.supplier.banknumber
            sup1.bank_holder_name=this.supplier.bankholder
            sup1.ifsc_code=this.supplier.bankifsc
            sup1.branch=this.supplier.bankbranch
            sup1.micr_code=this.supplier.bankmicr
            sup1.swift_code=this.supplier.bankswift

            this.$http.post('/api/suppliers/update?where[supplier_id]='+this.supplier_id,sup1).then(function (response){
              _this.$http.post('/api/supplierbanks/update?where[supplier_id]='+_this.supplier_id,sup1).then(function (response){
                _this.$http.post('/api/supplierdetails/update?where[supplier_id]='+_this.supplier_id,sup1).then(function (response){
                  _this.loading=false
                  _this.category=response.data;
                  _this.hasErrors.message=true;
                  _this.errorMessage.message=' Supplier Updated Successfully';
                  setTimeout(function(){ _this.errorMessage.message='';}, 2000);
                  _this.reset();
                  _this.getSupplier();
                  _this.largeModal=false
                })
                .catch(function (error) {
                  _this.loading=false
                });
              })
              .catch(function (error) {
                _this.loading=false
              });
            })
            .catch(function (error) {
              _this.loading=false
            });
          });        
      }
    },

    Submit(){
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;

      var submit_true = this.validation()
      var _this=this

      if (submit_true=='0') {
        this.loading=true
        var sup = {};

          Promise.all([this.image1(),this.image2(),this.image3(),this.image4(),this.image5()]).then(user=>{
            sup.sup_cmp_name=this.supplier.name

            if(this.suptype != null){
              sup.sup_cmp_type=this.suptype.id
            }else{
              sup.sup_cmp_type=null
            }

            sup.address1=this.supplier.add
            sup.address2=this.supplier.add2
            sup.pincode=this.supplier.pin

            if(this.city != null){
              sup.city=this.city.id
            }else{
              sup.city=null       
            }

            if(this.state != null){
              sup.state_code=this.state.id
            }else{
              sup.state_code=null
            }

            if(this.con != null){
              sup.country_code=this.con.id
            }else{
              sup.country_code=null
            }

            sup.sup_cmp_phone=this.supplier.phone
            sup.sup_cmp_email=this.supplier.email
            sup.sup_cmp_gst=this.supplier.gst
            sup.sup_cmp_pan=this.supplier.pan
            sup.sup_cmp_cin=this.supplier.cin
            sup.sup_cmp_tan=this.supplier.tan
            sup.contact_person_name=this.supplier.contact
            sup.contact_no=this.supplier.contactno
            sup.contact_email=this.supplier.contactemail
            sup.sup_cmp_cic_cert=user[0]
            sup.sup_cmp_gst_cert=user[1]
            sup.sup_cmp_pan_cert=user[2]
            sup.sup_cmp_tan_cert=user[3]
            sup.sup_cmp_logo=user[4]
            sup.sup_cmp_profile=this.supplier.profile
            sup.bank_name=this.supplier.bankname
            sup.acc_number=this.supplier.banknumber
            sup.bank_holder_name=this.supplier.bankholder
            sup.ifsc_code=this.supplier.bankifsc
            sup.branch=this.supplier.bankbranch
            sup.micr_code=this.supplier.bankmicr
            sup.swift_code=this.supplier.bankswift

            this.$http.post('/api/suppliers',sup).then(function (response){
              _this.loading=false
              _this.category=response.data;
              _this.hasErrors.message=true;
              _this.errorMessage.message=' Supplier Added';
              setTimeout(function(){ _this.errorMessage.message='';}, 2000);
              _this.reset();
              _this.getSupplier();
              _this.largeModal=false
            })
            .catch(function (error) {
              _this.loading=false
            });
          });        
      }
    },

    reset(){
      var _this = this
      _this.supplier.name =''
      _this.suptype = null
      _this.supplier.add = ''
      _this.supplier.add2 = ''
      _this.supplier.pin = ''
      _this.con = null              
      _this.state = null
      _this.city = null
      _this.supplier.phone = ''
      _this.supplier.email = ''
      _this.supplier.gst = ''
      _this.supplier.pan = ''
      _this.supplier.cin = ''
      _this.supplier.tan = ''
      _this.supplier.contact = ''
      _this.supplier.contactno = ''
      _this.supplier.contactemail = ''
      document.getElementById("image1").value = ''
      document.getElementById("image2").value = ''
      document.getElementById("image3").value = ''
      document.getElementById("image4").value = ''
      document.getElementById("image5").value = ''
      _this.supplier.profile = ''
      _this.supplier.bankname = ''
      _this.supplier.banknumber = ''
      _this.supplier.bankifsc = ''
      _this.supplier.bankbranch = ''
      _this.supplier.bankmicr = ''
      _this.supplier.bankswift = ''
      _this.ed.image1=''
      _this.ed.image2=''
      _this.ed.image3=''
      _this.ed.image4=''
      _this.ed.image5=''
      _this.ed.image1_href=''
      _this.ed.image2_href=''
      _this.ed.image3_href=''
      _this.ed.image4_href=''
      _this.ed.image5_href=''
    },
  }
}
</script>
<style type="text/css">
  .modal-title{
  color:black;
  font-weight:bold;
  }
</style>



// WEBPACK FOOTER //
// src/views/purches/Supplier.vue